import WithRender from "../../templates/imageEditor/loadingEditor.html";
import { mapGetters } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters(["getShow"])
  },
  methods: {}
});
